import React from 'react';
import { metricDefinitions } from '../../data/vendoo';
export function MetricDefinitionsMock() {
  return <div className="flex h-full flex-col rounded-2xl bg-surface p-4 md:p-5" data-id="element-694" data-mp="1v1514yhn39tk">
      <div className="h-full rounded-xl bg-white p-4 shadow-sm" data-id="element-695" data-mp="29qt0hu69fyen">
        <p className="text-sm font-semibold text-fg" data-id="element-696" data-mp="29t5g40ojpwoj">Metric definitions</p>
        <p className="mt-0.5 text-[11px] text-fg-muted" data-id="element-697" data-mp="24shu5tf6c616">Agreed with the founders before any chart was drawn.</p>
        <dl className="mt-4 divide-y divide-line" data-id="element-698" data-mp="1h2ngj9n16dfv">
          {metricDefinitions.map(m => <div key={m.metric} className="py-2.5" data-id="element-699" data-mp="1c556th16vu6t">
              <dt className="text-xs font-semibold text-ink" data-id="element-700" data-mp="1r14dqockboad">{m.metric}</dt>
              <dd className="mt-0.5 font-mono text-[11px] leading-relaxed text-fg-muted" data-id="element-701" data-mp="1m1hxs75cntxv">{m.formula}</dd>
            </div>)}
        </dl>
      </div>
    </div>;
}